import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useKeycloak } from '@react-keycloak/web'
import SaveIcon from '@material-ui/icons/Save'

import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import searchPageContext from '../../FiltersComponent/context/context'
import { getSearchCriteriaToSave, getUserSFId, getErrorAlertDuration } from '../../Utility/Utility'
import getSavedSearch from '../../Utility/GetSavedSearch/GetSavedSearch'
import { saveSavedSearch } from '../../Services/propertySearchService'
import { pollMessageStatus } from '../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../PropertyList/Utility/PropertyListUtility'

const SaveNewSearch = props => {
    const { keycloak } = useKeycloak()
    const [searchName, setSearchName] = useState('')
    const [targetMarket, setTargetMarket] = useState(false)
    const { searchCriteria, setShowAlert, setalertProps, savedSearch,
        openModalWindow, fetchSavedSearch } = useContext(searchPageContext)
    const [saveClicked, setSaveClicked] = useState(false)

    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    function handleChange(e) {
        let { value } = e.target

        const isNameTargetMarket = value.toLowerCase() === 'target market' ? true : false

        if (isNameTargetMarket) {
            // Capitalize name
            value = value.toLowerCase()
            value = value.replace(/\b\w/g, l => l.toUpperCase())
            setTargetMarket(true)
        } else {
            setTargetMarket(false)
        }

        setSearchName(value)
    }

    // const fetchSavedSearch = async () => {
    //     const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch, true)
    //     await getSavedSearchObj.fetchSavedSearch()
    // }

    const getPayload = () => {
        const user_SFId = getUserSFId()
        const isNameTargetMarket = searchName.toLowerCase() === 'target market' ? true : false
        const newSearchCriteria = getSearchCriteriaToSave(searchCriteria)

        const payload = {
            'action': 'add',
            'data': {
                'ownerId': user_SFId,
                'userId': keycloak.subject,
                'omniViewUserId': user_SFId,
                'isCart': false,
                'isTargetMarket': isNameTargetMarket,
                'name': searchName,
                'polarisSearchCriteria': JSON.stringify(newSearchCriteria),
                'omniViewSearchCriteria': '',
                "polarisUserName": keycloak.tokenParsed.name
            }
        }
        return payload
    }

    const validiateSearchExists = () => {
        let isExisits = false
        let newSearchName = searchName.trim()
        const index = savedSearch.findIndex(x => x.name.toLowerCase() === newSearchName.toLowerCase() && !x.isCart)
        if (index !== -1) {
            isExisits = true
        }

        return isExisits
    }

    const handleCheck = e => {
        if (!targetMarket) {
            setSearchName('Target Market')
        }
        setTargetMarket(!targetMarket)
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedSearch()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleSave = async () => {
        try {
            setSearchName(searchName.trim())

            if (validiateSearchExists()) {
                setalertProps({ message: `Search with Name ${searchName} already exist!!`, type: 'error' })
                setShowAlert(true)
                setSaveClicked(false)
                return
            }

            let response
            if (await readyToUpdate()) {
                const payload = getPayload()
                setSearchName('')
                openModalWindow(true)
                props.handleClose()
                response = await saveSavedSearch(payload)
            } else {
                response = await pendingResponse()
            }

            setSaveClicked(false)

            if (response && response.status === 200) {
                let messageId = response.data.messageId
                pollMessageStatus(messageId, onUpdate, '', 'Search Saved!!', 'It is taking longer than usual to save search. Please refresh and check saved search after some time')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

            // if (response && response.status === 200) {
            //     setTimeout(function () {
            //         fetchSavedSearch()
            //         setalertProps({ message: 'Search Saved!!', type: 'success' })
            //         setShowAlert(true)
            //         props.handleClose()
            //     }, 3000)

            // } else {
            //     setalertProps({ message: 'Something went wrong!! ', type: 'error' })
            //     setShowAlert(true)
            //     props.handleClose()
            // }

        }
        catch (e) {
            console.log('Error :: ', e)
        }
    }

    return (
        <>
            <div data-testid="test-div-new-save-search" className='flex flex-col py-4 gap-4 drawer-w'>
                <div className='flex flex-row border-b-1 border-base px-4 pb-2'>
                    <span className='pb-4'>
                        <SaveIcon></SaveIcon>
                    </span>
                    <span className='px-2'>
                        Save new search
                    </span>
                </div>
                <div className='pt-4 pb-8 border-b-1 border-base px-8 flex flex-col gap-2'>
                    <div className='text-2'>
                        <label>Search Name</label>
                    </div>
                    <div>
                        <SimpleInputField testid="test-txt-save-new-search" value={searchName} onChange={handleChange} type='' placeholder=''></SimpleInputField>
                    </div>
                    <div className="flex justify-end">
                        <div>
                            <input data-testid="test-NewSearch-IsTargetMarket" onChange={handleCheck} checked={targetMarket} id="chkTargetMarket" name="chkTargetMarket" type="checkbox" value="chkIsTargetMarket" />
                            <label className="px-3" htmlFor="chkTargetMarket">Is Target Market</label>
                        </div>
                    </div>
                </div>
                <div className='py-2 px-4'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-button-cancel-save-search' onClick={props.handleClose} className='btn btn-sm' type='button'>Close</button>
                        </div>
                        <div>
                            {saveClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Saving</span>
                                </button>
                                :
                                <button disabled={searchName.length === 0 ? true : false} data-testid='test-button-save-search' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary ${searchName.length === 0 ? 'c-disabled' : ''}`}>Save</button>
                            }
                            {/* <button data-testid='test-button-save-search' onClick={handleSave} className={`btn btn-sm btn-primary ${searchName.length === 0 ? 'c-disabled' : ''}`}>Save</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SaveNewSearch

SaveNewSearch.propTypes = {
    handleClose: PropTypes.any,
}
